import Vue from "vue";
import Vuetify from "vuetify";
import colors from "vuetify/lib/util/colors";
import "vuetify/dist/vuetify.min.css";
import "@mdi/font/css/materialdesignicons.css";
import fr from 'vuetify/src/locale/fr.ts'
Vue.use(Vuetify);
const options = {
    theme: {
        light: true,
        themes: {
            light: {
                // primary: "#1867C0",
                primary:"#ac1a17",
                accent: colors.grey.darken3,
                secondary: "#01348D",
                info: colors.teal.lighten1,
                warning: colors.amber.base,
                error: colors.red.darken3,
                success: colors.green.darken3,
                background: "#f5f5f5"
            }
        }
    },
    icons: {
        iconfont: "mdi"
    },
    lang: {
       current: 'fr',
         locales: {
             fr
         }
    }
};

export default new Vuetify(options);
